import { useApolloModel } from 'vue-apollo-model';
import { CurrentUserModel } from '@/models/current-user';
import { useBroadcast } from '@/common/utils';
import { useLog } from '@/common/log';
import { LoginSource } from '@/common/const';
import { computed } from '@vue/composition-api';


export function useIsLogin() {
    const broadcast = useBroadcast();
    const currentUserModel = useApolloModel(CurrentUserModel);
    const isLogin = computed(() => {
        return !!currentUserModel.userInfo.id;
    });
    const log = useLog();

    function alertLogin(obj: any) {
        broadcast('login', obj);
    }

    function login(item: any, isDarkMode?: boolean) {
        const logItemName = item.name;
        if (item.id === 'follow' && !isDarkMode) {
            log({
                type: 'CLICK',
                event_name: 'FAST_ENTRY_BUTTON',
                event_value: {
                    icon: logItemName,
                },
            });
        }
        if (!isLogin.value && item.id === 'follow') {
            alertLogin({
                // 登录源，供日志上报使用
                source: LoginSource.MYFOLLOW,
                redirect: item.link,
                open: true,
            });
            return;
        }
    }
    return {
        login,
        isLogin,
        alertLogin,
    };
}